import React, { useState } from 'react';
import { DashboardHeader } from '../components/DashboardHeader';
import { ActivityMetrics } from '../components/ActivityMetrics';
import { ConversionFunnel } from '../components/ConversionFunnel';
import { PerformanceProjections } from '../components/PerformanceProjections';
import { PersonalScorecard } from '../components/PersonalScorecard';
import { Leaderboard } from '../components/Leaderboard';
import { GamificationPanel } from '../components/GamificationPanel';
import { mockDataByTimeframe, Timeframe } from '../data/mockData';
export function WarRoomDashboard() {
  const [timeframe, setTimeframe] = useState<Timeframe>('Today');
  const data = mockDataByTimeframe[timeframe];
  return <div className="min-h-screen bg-slate-950 text-slate-200 font-sans selection:bg-cyan-500/30" data-id="element-171">
      <DashboardHeader timeframe={timeframe} setTimeframe={setTimeframe} data-id="element-172" />

      <main className="p-4 sm:p-6 max-w-[1600px] mx-auto space-y-6" data-id="element-173">
        {/* Row 1: Core Activity Metrics */}
        <ActivityMetrics metrics={data.metrics} data-id="element-174" />

        {/* Row 2: Funnel & Projections */}
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-6" data-id="element-175">
          <div className="lg:col-span-7" data-id="element-176">
            <ConversionFunnel funnel={data.funnel} data-id="element-177" />
          </div>
          <div className="lg:col-span-5" data-id="element-178">
            <PerformanceProjections projections={data.projections} data-id="element-179" />
          </div>
        </div>

        {/* Row 3: Scorecard, Leaderboard, Gamification */}
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-6" data-id="element-180">
          <div className="lg:col-span-4" data-id="element-181">
            <PersonalScorecard scorecard={data.scorecard} data-id="element-182" />
          </div>
          <div className="lg:col-span-4" data-id="element-183">
            <Leaderboard leaderboard={data.leaderboard} data-id="element-184" />
          </div>
          <div className="lg:col-span-4" data-id="element-185">
            <GamificationPanel gamification={data.gamification} data-id="element-186" />
          </div>
        </div>
      </main>
    </div>;
}